import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CommunityWebPostEmbedCard } from '@shared/dream-components';

import type { CommunityPostEmbedAttachable } from '~/interfaces/community';
import { communityImageSrc } from '~/routes/community/_utils/communityImageSrc';

import { PostLink } from '../PostLink';

interface PostEmbedCardProps {
  postId?: string;
  attachable: CommunityPostEmbedAttachable;
}

export const PostEmbedCard: FC<PostEmbedCardProps> = ({ postId, attachable }) => {
  const { t } = useTranslation();

  const cardContent = (
    <CommunityWebPostEmbedCard
      post={{
        id: attachable.id,
        web_title: attachable.web_title,
        web_subtitle: attachable.web_subtitle,
        image_url: attachable.image_url,
        publication_logo_url: attachable.publication_logo_url,
        publication_via_label: t('community.post_embed_card.via', { name: attachable.publication_name }),
      }}
      transformImageUrl={communityImageSrc}
    />
  );

  if (postId) {
    return (
      <PostLink postId={postId} className="block">
        {cardContent}
      </PostLink>
    );
  }

  return cardContent;
};
